import React, { useState, useEffect } from 'react';
import { useForgotPasswordMutation } from '../../store/api/userApiSlice';
import InputField from './InputField';
import './Auth.css';

function ForgotPasswordForm({ onSwitchToLogin, onSwitchToSignup, onClose }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // API mutation
  const [forgotPassword, { isLoading, error: apiError, isSuccess }] = useForgotPasswordMutation();

  // Handle API errors
  useEffect(() => {
    if (apiError) {
      setError(apiError?.data?.message || 'Failed to send reset link. Please try again.');
    }
  }, [apiError]);

  // Handle success
  useEffect(() => {
    if (isSuccess) {
      setSuccess('Reset password link sent successfully.');
    }
  }, [isSuccess]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setError('');
    setSuccess('');

    if (!email) {
      setError('Email is required');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Email is invalid');
      return;
    }

    try {
      await forgotPassword({ email }).unwrap();
      // Success is handled by the useEffect above
    } catch (err) {
      console.error('Forgot password failed:', err);
      // Error is handled by useEffect watching apiError
    }
  };

  return (
    <form className="forgot-password-form" onSubmit={handleSubmit}>
      <h1 className="form-title">Forget Password?</h1>

      {error && (
        <div className="error-banner">
          {error}
          <button 
            type="button" 
            className="error-close"
            onClick={() => setError('')}
          >
            ×
          </button>
        </div>
      )}

      {success && (
        <div className="success-banner">
          {success}
          <button 
            type="button" 
            className="success-close"
            onClick={() => setSuccess('')}
          >
            ×
          </button>
        </div>
      )}

      <p className="forgot-description">
        {success 
          ? `A reset password link has been sent to your registered email .i.e. ${email.replace(/(.{2})(.*)(@.*)/, '$1*********$3')}`
          : 'We will send a reset password link to your registered email address, use that link to reset your password.'
        }
      </p>

      {!success && (
        <>
          <InputField
            label="Email Address"
            type="email"
            name="email"
            placeholder="Eg: Johndoe@email.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
            }}
          />

          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? 'SENDING...' : 'SEND LINK'}
          </button>
        </>
      )}

      <button type="button" onClick={onSwitchToLogin} className="back-btn">
        BACK TO LOG IN
      </button>

      <p className="signup-link">
        Don't have an account?{' '}
        <button type="button" onClick={onSwitchToSignup} className="link-btn">
          Click here to Sign Up!
        </button>
      </p>
    </form>
  );
}

export default ForgotPasswordForm;
